// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".teaser[data-v-7dcc3441]{padding:10px;font-style:normal;font-weight:400;font-size:16px;line-height:22px;text-align:justify}", ""]);
// Exports
module.exports = exports;
